(function () {
  var STORAGE_KEY = 'yt-us-store-stay';
  var US_HOME = 'https://us.yopandtom.com/';
  var root = document.getElementById('us-store-prompt');

  if (!root || (window.Shopify && window.Shopify.designMode)) return;

  var banner = root.querySelector('[data-us-banner]');
  var bannerText = root.querySelector('[data-us-banner-text]');
  var bannerGo = root.querySelector('[data-us-banner-go]');
  var modal = root.querySelector('[data-us-modal]');
  var dialogText = root.querySelector('[data-us-dialog-text]');
  var dialogGo = root.querySelector('[data-us-dialog-go]');
  var pageKind = root.getAttribute('data-page-kind') || 'other';
  var pageUrl = root.getAttribute('data-us-url') || US_HOME;
  var pageMatched = root.getAttribute('data-us-matched') === 'true';
  var isUs = false;
  var pending = null;
  var lastFocus = null;

  function stayed() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function rememberStay() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  }

  function generalCopy() {
    return {
      text: 'Shopping from the US? This site ships to the UK.',
      go: 'Shop the US store'
    };
  }

  function itemOnlyCopy() {
    return {
      text: 'This item ships from the UK only.',
      go: 'Browse the US store'
    };
  }

  function bannerCopy() {
    if ((pageKind === 'product' || pageKind === 'collection') && !pageMatched) {
      return itemOnlyCopy();
    }
    return generalCopy();
  }

  function showBanner() {
    var copy = bannerCopy();
    bannerText.textContent = copy.text;
    bannerGo.textContent = copy.go;
    bannerGo.href = pageUrl;
    banner.hidden = false;
  }

  function hideBanner() {
    banner.hidden = true;
  }

  function closeDialog() {
    modal.hidden = true;
    document.body.style.overflow = '';
    pending = null;
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
    lastFocus = null;
  }

  function destination(form) {
    var url = '';
    if (form) {
      url = form.getAttribute('data-us-store-url') || '';
      if (!url) {
        var parent = form.closest('[data-us-store-url]');
        if (parent) url = parent.getAttribute('data-us-store-url') || '';
      }
    }
    if (url) return { url: url, matched: true };
    if (pageKind === 'product' && pageMatched) return { url: pageUrl, matched: true };
    return { url: US_HOME, matched: false };
  }

  function openDialog(form, button) {
    var dest = destination(form);
    var copy = dest.matched
      ? { text: 'This site ships to the UK. Shop this product in the US.', go: 'Shop the US store' }
      : { text: 'This product ships from the UK only.', go: 'Browse the US store' };

    dialogText.textContent = copy.text;
    dialogGo.textContent = copy.go;
    dialogGo.href = dest.url;
    pending = { form: form, button: button || null };
    lastFocus = button || document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    dialogGo.focus();
  }

  function resumeAdd() {
    var job = pending;
    closeDialog();
    if (!job || !job.form) return;

    job.form.setAttribute('data-us-prompt-pass', '1');
    if (job.button && job.button.type !== 'submit') {
      job.button.click();
      return;
    }
    if (typeof job.form.requestSubmit === 'function') {
      job.form.requestSubmit(job.button || undefined);
    }
  }

  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = (form.getAttribute('action') || '').toLowerCase();
    return action.indexOf('/cart/add') !== -1;
  }

  function shouldGate() {
    return isUs && !stayed();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isCartAddForm(form)) return;
    if (document.body.classList.contains('cart')) return;
    if (form.getAttribute('data-us-prompt-pass') === '1') {
      form.removeAttribute('data-us-prompt-pass');
      return;
    }
    if (!shouldGate()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openDialog(form, event.submitter || null);
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest(
      '.ajax-submit, button.add_to_cart, button.product-form__submit[name="add"], button.product-card__cta[name="add"], button.hp-product-row__cta[name="add"], button.hp-featured-split__cta[name="add"], .restock-rocket-preorder-button'
    );
    if (!button || button.disabled || button.type === 'submit') return;

    var form = button.closest('form');
    if (!isCartAddForm(form)) return;
    if (document.body.classList.contains('cart')) return;
    if (form.getAttribute('data-us-prompt-pass') === '1') {
      form.removeAttribute('data-us-prompt-pass');
      return;
    }
    if (!shouldGate()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openDialog(form, button);
  }, true);

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-us-stay]')) {
      rememberStay();
      hideBanner();
      closeDialog();
      return;
    }
    if (event.target.closest('[data-us-dialog-add]')) {
      rememberStay();
      hideBanner();
      resumeAdd();
      return;
    }
    if (event.target.closest('[data-us-dialog-close]')) {
      closeDialog();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal && !modal.hidden) {
      closeDialog();
    }
  });

  function activate() {
    isUs = true;
    if (!stayed()) showBanner();
  }

  var force = false;
  try {
    force = new URLSearchParams(window.location.search).get('yt-us-preview') === '1';
  } catch (e) {}

  if (stayed()) return;

  if (force) {
    isUs = true;
    showBanner();
    return;
  }

  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(rootPath + 'browsing_context_suggestions.json', { credentials: 'same-origin' })
    .then(function (response) { return response.json(); })
    .then(function (data) {
      var country = data && data.detected_values && data.detected_values.country;
      var handle = country && (country.handle || country.iso_code) || '';
      if (String(handle).toUpperCase() === 'US') activate();
    })
    .catch(function () {});
})();
